/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Email_BouncedInputs */

const en_task_email_bounced = /** @type {(inputs: Task_Email_BouncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The email could not be delivered to the assignee`)
};

const pt_br2_task_email_bounced = /** @type {(inputs: Task_Email_BouncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O e-mail não pôde ser entregue ao responsável`)
};

/**
* | output |
* | --- |
* | "The email could not be delivered to the assignee" |
*
* @param {Task_Email_BouncedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_email_bounced = /** @type {((inputs?: Task_Email_BouncedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Email_BouncedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_email_bounced(inputs)
	return pt_br2_task_email_bounced(inputs)
});